import { toast } from "react-hot-toast";

const errorHandler = (error, position = "top-right") => {
    const option = {
        position,   // e.g. "top-right", "bottom-center"
        duration: 5000
    };

    if (error.response) {
        switch (error.response.status) {
            case 401:
                toast.error("Invalid Email address or password!", option);
                break;

            case 422:
                toast.error(
                    error.response.data["error"].details !== undefined
                        ? error.response.data["error"].details[0].message
                        : error.response.data["error"],
                    option
                );
                break;

            default:
                toast.error("Error 446: Something went wrong!.", option);
        }
    } else {
        toast.error("Error 500: Server connection failed!.", option);
    }
};

export default errorHandler;
